
define('app/dashboard/dashboardApp',[
	'jquery',
	'underscore',
	'backbone',
	'known/knownUtil',
	'known/collections/productCollection',
	'known/collections/leagueInstanceCollection',
	'known/views/productLeaguesView',
	'known/models/userModel'
], function($, _, Backbone, KnownUtil, ProductCollection, LeagueInstanceCollection, ProductLeaguesView, UserModel){
	var initialize = function(){
		var initialModels = KnownUtil.setupSideNav();
		var userModel = initialModels.userModel;
		var prodCollection = initialModels.prodCollection;
		var leagueCollection = initialModels.leagueCollection;
		
		prodCollection.each(function(product){
			if(_.size(product.activeProducts()) > 0){
				var prodLgsView = new ProductLeaguesView({userModel: userModel, product: product, leagueCollection: leagueCollection});
				var prodEl = prodLgsView.render().el;
				$(prodEl).find('.lgsContainerOldDrafts').show();
				$("#content > .wrapper").append(prodEl);
			}
		});		
	};
	
	return {
		initialize: initialize
	};
});